// --
import React from 'react';
import {DetailLeftIcon, Icon, utils} from './../index';
import {Alert} from "reactstrap";
import * as SubjektTools from "./SubjektTools";

/**
 * Komponenta pro zobrazení informace o úmrtí nebo zániku subjektu.
 */
export default class SubjektUmrtiInfo extends React.Component {
    static PropTypes = {
        subjekt: React.PropTypes.object,  // subjekt
    };

    render() {
        const {className, subjekt} = this.props;

        if (!subjekt) {
            return <span></span>;
        }

        const deadInfo = SubjektTools.getDeadInfo(subjekt);
        if (deadInfo.dead) {
            return <Alert className={className} color="warning"><DetailLeftIcon icon={<Icon icon="user-times"/>}>{deadInfo.title}</DetailLeftIcon></Alert>;
        } else {
            return <span></span>;
        }
    }
}
